import { Avatar } from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import React from 'react';

const TestimonialCard = ({testimonial}) => {
    return (
        <div className="col-md-4 ms-3 p-3 mb-5" style={{width: '18rem', background: 'white', borderRadius: '10px'}}>
            <div className="d-flex">
            <Avatar alt="..." src={testimonial.user} />
                <div className="ms-2">
                    <h6><b>{testimonial.name}</b></h6>
                    <small><b>{testimonial.designation}</b></small>
                </div>
            </div>
            <p>{testimonial.review}</p>
            <Rating name="read-only" value={testimonial.value} readOnly />
        </div>
    );
};

export default TestimonialCard;